
export enum ResolutionPresets {
	AutoHalved = "auto-halved",
	Video360 = "video-360"
};

export enum SegmentType {
	MPEGTS = "mpegts",
	FMP4 = "fmp4"
};

export enum FFEncoder {
	H264 = "libx264",
	H264_NVIDIA = "h264_nvenc",
};

export enum H264Preset {
	UltraFast = "ultrafast",
	SuperFast = "superfast",
	VeryFast = "veryfast",
	Faster = "faster",
	Fast = "fast",
	Medium = "medium",
	Slow = "slow",
	Slower = "slower",
	VerySlow = "veryslow",
};

export enum GPUMode {
	None = "none",
	Cuda = "nvidia-cuda",
	CudaEncoder = "nvidia-cuda-nvenc",
};

export enum BitrateMode {
	Simple1 = "fixed-1",
	SimpleSpaced2 = "fixed-2-spaced",
	SimpleSpaced3 = "fixed-3-spaced",
	SimpleSpaced4 = "fixed-4-spaced"
};

export type LadderConfig = {
	w:number;
	h:number;
	br:number;
	fr:number;
	preset?:string;
	segmentLength:number;
	bufferScale:number;
	sizingMode?:string;
	bitrateMode?:string;
};

export type Size2D = {
	w:number;
	h:number;
};

export type VideoData = {
	w:number;
	h:number;
	br:number;
	fr:number;
};
